export const GET_PAY_OUT_STATUS_DEF= "GET_PAY_OUT_STATUS_DEF"
export const GET_PAY_OUT_STATUS_DEF_SUCCESS = "GET_PAY_OUT_STATUS_DEF_SUCCESS"
export const GET_PAY_OUT_STATUS_DEF_FAIL = "GET_PAY_OUT_STATUS_DEF_FAIL"

export const PAY_OUT_STATUS_DEF_API_ERROR = "API_ERROR"